import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './translations/en/common.json';
import enAdmin from './translations/en/admin.json';
import enLogin from './translations/en/login.json';
import enSettings from './translations/en/settings.json';
import enGoalAreas from './translations/en/goalAreas.json';
import enProperty from './translations/en/property.json';
import enArea from './translations/en/area.json';
import enGeocoder from './translations/en/geocoder.json';

import svCommon from './translations/sv/common.json';
import svAdmin from './translations/sv/admin.json';
import svLogin from './translations/sv/login.json';
import svSettings from './translations/sv/settings.json';
import svGoalAreas from './translations/sv/goalAreas.json';
import svProperty from './translations/sv/property.json';
import svArea from './translations/sv/area.json';
import svGeocoder from './translations/sv/geocoder.json';

const defaultNS = 'common' as const;
const resources = {
  en: {
    common: enCommon,
    admin: enAdmin,
    login: enLogin,
    settings: enSettings,
    goalAreas: enGoalAreas,
    property: enProperty,
    area: enArea,
    geocoder: enGeocoder,
  },
  sv: {
    common: svCommon,
    admin: svAdmin,
    login: svLogin,
    settings: svSettings,
    goalAreas: svGoalAreas,
    property: svProperty,
    area: svArea,
    geocoder: svGeocoder,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    supportedLngs: ['en', 'sv'],
    fallbackLng: 'en',
    ns: [
      'common',
      'admin',
      'login',
      'settings',
      'goalAreas',
      'property',
      'area',
      'geocoder',
    ],
    defaultNS,
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

// resolvedLanguage is always defined when supportedLngs and fallbackLng are set
declare module 'i18next' {
  interface i18n {
    resolvedLanguage: string;
  }
}
